// ============================================================
// GEM (Match-3 tile)
// ============================================================

import { M3 } from './constants.ts';
import { nextId, ri } from './utils.ts';
import { SeededRng } from './server/rng.ts';

export class Gem {
  id: number;
  el: number;
  r: number;
  c: number;
  // Visual position (for animation)
  vx: number;
  vy: number;
  scale: number;
  alpha: number;

  /**
   * @param r         Row index.
   * @param c         Column index.
   * @param el        Optional explicit element — if omitted, rolled from `rng` (or Math.random).
   * @param rng       Deterministic RNG source. Pass the board's RNG so gem generation is reproducible.
   * @param elements  Session 9 — optional explicit element pool (the active leader's
   *                  `gemElements`). When omitted, falls back to the legacy
   *                  contiguous range `M3.minGemElement..M3.maxGemElement`.
   *                  Passed by `M3Board._applyGravityAnimated` so newly-spawned
   *                  gems honour the current leader's color palette.
   */
  constructor(
    r: number,
    c: number,
    el?: number,
    rng?: SeededRng | null,
    elements?: ReadonlyArray<number>,
  ) {
    this.id = nextId();
    if (el !== undefined) {
      this.el = el;
    } else if (elements && elements.length > 0) {
      const idx = rng ? rng.nextInt(0, elements.length - 1) : ri(0, elements.length - 1);
      this.el = elements[idx];
    } else if (rng) {
      this.el = rng.nextInt(M3.minGemElement, M3.maxGemElement);
    } else {
      this.el = ri(M3.minGemElement, M3.maxGemElement);
    }
    this.r = r;
    this.c = c;
    this.vx = c;
    this.vy = r;
    this.scale = 1;
    this.alpha = 1;
  }
}
